import cx from 'classnames';
import { ContentContainer } from 'themes/organic/components/ContentContainer';
import {
  CtaButton,
  EllipseOutline,
  TexturedCircle,
} from 'themes/organic/components/index';

import s from './Hero.module.css';

interface HeroProps {
  imgSrc: string;
  href: string;
}

const Hero = ({ imgSrc, href }: HeroProps) => {
  return (
    <section className={cx(s.hero)}>
      <ContentContainer>
        <div className={s.ellipse} />
        <EllipseOutline className={s.ellipseOutline} />
        <div
          className={s.background}
          style={{
            backgroundImage: `url(${imgSrc})`,
          }}
        />
        <div className={s.content}>
          <TexturedCircle className={s.texturedCircle} />

          <div className={cx(s.container)}>
            <CtaButton title="Book now" href={href}>
              book now
            </CtaButton>
          </div>
        </div>
      </ContentContainer>
    </section>
  );
};

export { Hero };
